import jump from 'jump.js';

const jumpToLocation = (elementRef, offset = -30, duration = 1000) => {
  jump(elementRef, { offset, duration });
};

export default jumpToLocation;
